export default "__VITE_ASSET__5e45fc71__"